import {FieldTypeEnum} from '../../../../../projects/mydocma/dynamic-form/src/lib/dynamic-field/field-type.enum';
import {Validators} from '@angular/forms';
import {
    ButtonFieldConfig
} from '../../../../../projects/mydocma/dynamic-form/src/lib/fields/button/button-field.config';
import {
    FilterSelectFieldConfig
} from '../../../../../projects/mydocma/dynamic-form/src/lib/fields/filter-select/filter-select-field.config';
import {LabelFieldConfig} from '../../../../../projects/mydocma/dynamic-form/src/lib/fields/label/label-field.config';
import { SlideToggleFieldConfig } from 'projects/mydocma/dynamic-form/src/public-api';

export const configFields = [
    {
        id: 'label2',
        name: 'label2',
        type: FieldTypeEnum.label,
        label: {text: 'text to bind'},
        attachToField: {name: 'text1'},

    } as LabelFieldConfig,
    {
        id: 'select1',
        name: 'select1',
        type: FieldTypeEnum.select,
        label: {text: 'fields.select1'},
        required: true,

        value: 'item1',
        source: [
            // {id: 'item1', text: '1'}, {id: 'item2', text: '2'}
        ],
        // getSource: this.getSelectSource
    },
    {
        id: 'text1',
        name: 'text1',
        // required: true,
        type: FieldTypeEnum.text,
        label: {text: 'fields.text1'},
        required: true
    },
    {
        id: 'button1',
        name: 'button1',
        type: FieldTypeEnum.button,
        label: {text: 'fields.button1'},
        hidden: false,
    } as ButtonFieldConfig,
    {
        id: 'text2',
        name: 'text2',
        type: FieldTypeEnum.text,
        label: {text: 'fields.text2'},
    },
    {
        id: 'text3',
        name: 'text3',
        type: FieldTypeEnum.text,
        label: {text: 'fields.text3'}
    },
    {
        id: 'text4',
        name: 'text4',
        type: FieldTypeEnum.text,
        label: {text: 'fields.text4'}
    },
    {
        id: 'text5',
        name: 'text5',
        type: FieldTypeEnum.text,
        label: {text: 'fields.text4'}
    },
    {
        id: 'text6',
        name: 'text6',
        type: FieldTypeEnum.text,
        label: {text: 'fields.text6'}
    },
    {
        id: 'text7',
        name: 'text7',
        type: FieldTypeEnum.text,
        label: {text: 'fields.text7'}
    },
    {
        id: 'textarea1',
        name: 'textarea1',
        type: FieldTypeEnum.textarea,
        label: {text: 'fields.textarea1'},
        required: true,
        // maxLength: 12,
        // minLength: 2,
        // maxRows: 10,
        // minRows: 2,
        // hidden: false,
    },
    {
        id: 'number1',
        name: 'number1',
        type: FieldTypeEnum.number,
        label: {text: 'fields.number1'},
        required: true,
        readonly: false,
        maxValue: 12,
    },
    {
        id: 'label1',
        name: 'label1',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label1'},
    },
    {
        id: 'label3',
        name: 'label3',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label3'},
    },
    {
        id: 'label4',
        name: 'label4',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label4'},
    },
    {
        id: 'label5',
        name: 'label5',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label5'},
    },
    {
        id: 'label6',
        name: 'label6',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label6'},
    },
    {
        id: 'label7',
        name: 'label7',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label7'},
    },
    {
        id: 'label8',
        name: 'label8',
        type: FieldTypeEnum.label,
        label: {text: 'fields.label8'},
    },
    {
        id: 'select1',
        name: 'select1',
        type: FieldTypeEnum.select,
        label: {text: 'fields.select1'},
        required: true,
        source: [{id: 'item1', text: '1'}, {id: 'item2', text: '2'}],
    },
    {
        id: 'checkbox1',
        name: 'checkbox1',
        type: FieldTypeEnum.checkbox,
        label: {text: 'fields.checkbox1'},
        validators: [Validators.requiredTrue],
        // hidden: false,
        required: true
    },
    {
        id: 'date1',
        name: 'date1',
        type: FieldTypeEnum.date,
        label: {text: 'fields.date1'},
        required: false,
        disabled: false,
        readonly: false,
        maxDate: new Date(2020, 0, 1),
        hidden: false
    },
    {
        id: 'datetime1',
        name: 'datetime1',
        label: {text: 'fields.datetime1'},
        type: FieldTypeEnum.datetime,
        required: true,
        hidden: false
    },
    {
        id: 'time1',
        name: 'time1',
        type: FieldTypeEnum.time,
        label: {text: 'fields.time1'},
        required: true,
        readonly: false
    },
    {
        id: 'button1',
        name: 'button1',
        type: FieldTypeEnum.button,
        label: {text: 'fields.button1'},
        hidden: false,
    } as ButtonFieldConfig,
    {
        id: 'icon1',
        name: 'icon1',
        type: FieldTypeEnum.icon,
        label: {text: 'fields.icon1'},
        value: 'search'
    },
    {
        id: 'image1',
        name: 'image1',
        type: FieldTypeEnum.image,
        // hidden: true,
        label: {text: 'fields.image1'},
        value: 'https://www.expatica.com/app/uploads/sites/6/2014/05/traditional-music-marienplatz-munich.jpg',
        width: '300px'
    },
    {
        id: 'image2',
        name: 'image2',
        type: FieldTypeEnum.image,
        label: {text: 'fields.image1'},
        value: 'https://www.expatica.com/app/uploads/sites/6/2014/05/Munich-night-1920x1080.jpg',
        width: '300px'
    },
    {
        id: 'image3',
        name: 'image3',
        type: FieldTypeEnum.image,
        label: {text: 'fields.image1'},
        value: 'https://cdnp.flypgs.com/files/Sehirler-long-tail/Kyiv/kyiv-alisveris.jpg',
        width: '300px'
    },
    {
        id: 'option1',
        name: 'option1',
        type: FieldTypeEnum.option,
        orientation: 'vertical',
        options: [{optionLabel: 'Paris', optionValue: 'Paris'}, {optionLabel: 'London', optionValue: 'London'}]
    },
    {
        id: 'toggle-slide',
        name: 'slidetoggle',
        type: FieldTypeEnum.slidetoggle,
        label: {text: 'fields.slidetoggle1'},
        required: true,
        allowLabelCollapse: true
    } as SlideToggleFieldConfig
];
